import React, { useState, useEffect } from 'react';
import { Button, Box, Avatar } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { apiBaseUrl } from '../utils/Api/Api';

const AvatarUploader = ({ pet, handleAvatarChange }) => {

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      handleAvatarChange(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Box display="flex" alignItems="center" flexDirection="column">
      {pet.avatar_url && (
        <Avatar
          src={`${apiBaseUrl}${pet.avatar_url}`}
          alt={pet.name}
          sx={{
            width: 160,
            height: 160,
            margin: 'auto',
            marginTop: 2,
            marginBottom: 2,
            border: '1px solid lightgray',
          }}
        />
      )}
      <Button
        variant="outlined"
        component="label"
        startIcon={<CloudUpload />}
      >
        Adicionar Foto
        <input type="file" hidden onChange={handleImageChange} />
      </Button>
    </Box>
  );
};

export default AvatarUploader;

